/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreateWorkerRequest { 
    name: string;
    displayName: string;
    clientId: string;
    statusId: number;
    poolId: string;
    coinId: number;
    observerLink?: string | null;
}

